// extracted by mini-css-extract-plugin
module.exports = {"langButton":"LanguageMenu_langButton__m5ihc","title":"LanguageMenu_title__VHkjY","radio":"LanguageMenu_radio__MV0uu","button":"LanguageMenu_button__Vcrkv"};